export default function generateUuid() {
	return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}


// WEBPACK FOOTER //
// ./src/utilities/api/generateUuid.js